import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";

const initialState = {
  error: null, // Ubah dari string kosong ke null untuk konsistensi
  loading: false,
  isUserLogout: false,
  user: null, // Tambahkan state user untuk menyimpan data user yang berhasil login
  token: null, // Tambahkan state token
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: null, // Penting: reset error saat login dimulai
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isUserLogout: false,
        error: null,
        user: action.payload.user, 
        token: action.payload.token, 
      };
    case LOGOUT_USER:
      return { 
        ...state, 
        loading: true 
      };
    case LOGOUT_USER_SUCCESS:
      return { 
        ...state, 
        isUserLogout: true,
        loading: false,
        user: null, // Penting: reset user saat logout
        token: null, // Penting: reset token saat logout
      };
    case API_ERROR:
      return {
        ...state,
        loading: false, // Hentikan loading
        error: action.payload, // Simpan pesan error
        isUserLogout: false,
        user: null, // Penting: pastikan data user bersih jika terjadi error
        token: null,
      };
    default:
      return state;
  }
};

export default login;